import { Question } from 'types/state'

type GetGymSectionDifficultyArgs = {
  gym_difficulty?: Question.GymDifficulty
  home_difficulty?: Question.HomeDifficulty
  workout_location?: Question.WorkoutLocation
}

export const getGymSectionDifficulty = ({
  gym_difficulty,
  home_difficulty,
  workout_location,
}: GetGymSectionDifficultyArgs) => {
  switch (workout_location) {
    case Question.WorkoutLocation.Gym:
    case Question.WorkoutLocation.Both:
      return gym_difficulty
    case Question.WorkoutLocation.HomeGym:
    case Question.WorkoutLocation.DoNotKnow:
      return home_difficulty
    default:
      return undefined
  }
}
